import comp from "./AIFeedbackStrip";
export default comp;
